// Foundation
import 'poly-eshop4/eshop/ui/js/foundation/foundation';
import 'poly-eshop4/eshop/ui/js/foundation/breakpoints';

// Foundation extensions
import 'poly-eshop4/eshop/ui/js/extensions/autofocus';
import 'poly-eshop4/eshop/ui/js/extensions/offcanvas';
import 'poly-eshop4/eshop/ui/js/extensions/map';
import 'poly-eshop4/eshop/ui/js/extensions/recaptcha';

// Stores
import 'poly-eshop4/eshop/ui/js/store/store';

// Base
import 'poly-eshop4/eshop/ui/js/confirm';
import 'poly-eshop4/eshop/ui/js/cookie';
import 'poly-eshop4/eshop/ui/js/add-to-cart';
import 'poly-eshop4/eshop/ui/js/fastentry';
import 'poly-eshop4/eshop/ui/js/cart';
import 'poly-eshop4/eshop/ui/js/checkout';
import 'poly-eshop4/eshop/ui/js/header';
import 'poly-eshop4/eshop/ui/js/items';
import 'poly-eshop4/eshop/ui/js/itemlist';
import 'poly-eshop4/eshop/ui/js/autocomplete';
import 'poly-eshop4/eshop/ui/js/search';
import 'poly-eshop4/eshop/ui/js/shoppinglist';
import 'poly-eshop4/eshop/ui/js/registration';
import 'poly-eshop4/eshop/ui/js/oci';
import 'poly-eshop4/eshop/ui/js/account';
// import 'poly-eshop4/eshop/ui/js/orderapproval';
import 'poly-eshop4/eshop/ui/js/object';
// import 'poly-eshop4/eshop/ui/js/exporter';
import 'poly-eshop4/eshop/ui/js/news';
import 'poly-eshop4/eshop/ui/js/cms';
import 'poly-eshop4/eshop/ui/js/lazyload';
import 'poly-eshop4/eshop/ui/js/statistics';
import 'poly-eshop4/eshop/ui/js/table';
import 'poly-eshop4/eshop/ui/js/comparisonlist';

// Payments
// import 'poly-eshop4/eshop/ui/js/datatrans';

// Workarounds
import 'poly-eshop4/eshop/ui/js/workaround/stickyfill';
import 'poly-eshop4/eshop/ui/js/workaround/ios-label-for';

// Import additional foundation plugins
import { Magellan } from 'foundation-sites/js/foundation.magellan';

// Indivs
import './cart';
import './scroll-to-top';

window.Foundation.plugin(Magellan, 'Magellan');
$('[data-magellan]').foundation();
